import { create } from 'zustand';

import { type CelebrationKind, type CelebrationLine, pickCelebrationLine } from './quotes';

interface CelebrationState {
  active: CelebrationLine | null;
  kind: CelebrationKind;
  /** Текущая серия дней — показывается в карточке при `kind === 'streak'`. */
  streak: number;
  celebrate: (kind?: CelebrationKind, streak?: number) => void;
  dismiss: () => void;
}

/**
 * Состояние праздничной анимации.
 *
 * Вынесено в глобальный store, потому что закрыть задачу можно с трёх разных
 * экранов (календарь, список задач, карточка цели), а оверлей должен быть один
 * и жить над всем интерфейсом.
 */
export const useCelebrationStore = create<CelebrationState>((set) => ({
  active: null,
  kind: 'task',
  streak: 0,
  celebrate: (kind = 'task', streak = 0) =>
    set({ active: pickCelebrationLine(kind), kind, streak }),
  dismiss: () => set({ active: null }),
}));

/** Короткий вызов из любого места: `celebrate('day')`. */
export function celebrate(kind: CelebrationKind = 'task', streak = 0): void {
  useCelebrationStore.getState().celebrate(kind, streak);
}
